// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function sms_detail_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var phone_number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "phone_number"), null));
  if (phone_number.TAG === /* Ok */0) {
    var message = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
    if (message.TAG === /* Ok */0) {
      var status = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
      if (status.TAG === /* Ok */0) {
        var order_id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_id"), null));
        if (order_id.TAG === /* Ok */0) {
          var created_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
          if (created_at.TAG === /* Ok */0) {
            var status_details = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status_details"), null));
            if (status_details.TAG === /* Ok */0) {
              var sms_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sms_id"), null));
              if (sms_id.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          phone_number: phone_number._0,
                          message: message._0,
                          status: status._0,
                          order_id: order_id._0,
                          created_at: created_at._0,
                          status_details: status_details._0,
                          sms_id: sms_id._0
                        }
                      };
              }
              var e = sms_id._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".sms_id" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = status_details._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".status_details" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = created_at._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".created_at" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = order_id._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".order_id" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = status._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".status" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = message._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".message" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = phone_number._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".phone_number" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var message_details = Decco.listFromJson(sms_detail_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "message_details"), null));
  if (message_details.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              message_details: message_details._0
            }
          };
  }
  var e = message_details._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".message_details" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  sms_detail_decode ,
  t_decode ,
  
}
/* No side effect */
